import { Component } from '@angular/core';
import {HttpClient} from "@angular/common/http";


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  revenueGoal = 10000000; // $10 million

    tokenDisplayMap = {
        BTC: {
            asset: "bitcoin-btc-logo.svg",
            color: "#f7931a",
            shortName: "BTC",
            name: "Bitcoin",
            height: 128,
            width: 128
        },
        ETH: {
            asset: "ethereum-eth-logo.svg",
            color: "#C99D66",
            shortName: "ETC",
            name: "Ethereum",
            height: 128,
            width: 79
        },
        BCH: {
            asset: "bitcoin-cash-bch-logo.svg",
            color: "#0ac18e",
            shortName: "BCH",
            name: "Bitcoin Cash",
            height: 128,
            width: 128
        },
        LTC: {
            asset: "litecoin-ltc-logo.svg",
            color: "#345d9d",
            shortName: "LTC",
            name: "Litecoin",
            height: 128,
            width: 128
        },
        COMP: {
            asset: "compound-comp-logo.svg",
            color: "#00d395",
            shortName: "COMP",
            name: "Compound",
            height: 128,
            width: 128
        },
        DOGE: {
            asset: "dogecoin-doge-logo.svg",
            color: "#ba9f33",
            shortName: "DOGE",
            name: "Dogecoin",
            height: 128,
            width: 128
        },
        FIL: {
            asset: "filecoin-fil-logo.svg",
            color: "#0090ff",
            shortName: "FIL",
            name: "Filecoin",
            height: 128,
            width: 128
        },
        LINK: {
            asset: "chainlink-link-logo.svg",
            color: "#2a5ada",
            shortName: "LINK",
            name: "Chainlink",
            height: 128,
            width: 112
        },
        XTZ: {
            asset: "tezos-xtz-logo.svg",
            color: "#2c7df7",
            shortName: "XTZ",
            name: "Tezos",
            height: 128,
            width: 94

        },
        ZEC: {
            asset: "zcash-zec-logo.svg",
            color: "#eeb747",
            shortName: "ZEC",
            name: "ZCash",
            height: 128,
            width: 128
        },
        USDC: {
            asset: "usd-coin-usdc-logo.svg",
            color: "#2775ca",
            shortName: "USDC",
            name: "USD Coin",
            height: 128,
            width: 128
        },
        CRV: {
            asset: "curve-dao-token-crv-logo.svg",
            color: "#840000",
            shortName: "CRV",
            name: "Curve DAO",
            height: 128,
            width: 127
        },
        GRT: {
            asset: "the-graph-grt-logo.svg",
            color: "#6747ED",
            shortName: "GRT",
            name: "The Graph",
            height: 128,
            width: 128
        },
        AMP: {
            asset: "amp-amp-logo.svg",
            color: "#D9327C",
            shortName: "AMP",
            name: "Amp",
            height: 128,
            width: 128
        },
        UNI: {
            color: "#FF007A",
            asset: "uniswap-uni-logo.svg",
            shortName: "UNI",
            name: "Uniswap",
            height: 128,
            width: 111
        },
        GUSD: {
            asset: "gemini-dollar-gusd-logo.svg",
            color: "#00dcfa",
            shortName: "GUSD",
            name: "Gemini Dollar",
            height: 128,
            width: 128
        },
        BAT: {
            asset: "basic-attention-token-bat-logo.svg",
            color: "#9e1f63",
            shortName: "BAT",
            name: "Basic Attention Token",
            height: 108,
            width: 108
        },
        AAVE: {
            asset: "aave-aave-logo.svg",
            color: "#b5519e",
            shortName: "AAVE",
            name: "Aave",
            height: 128,
            width: 128
        },
        DAI: {
          asset: "multi-collateral-dai-dai-logo.svg",
            color: "#f5ac37",
            shortName: "DAI",
            name: "Dai",
            height: 128,
            width: 128
        },
        USD: {
            asset: "usd-logo.png",
            color: "#85bb65",
            shortName: "USD",
            name: "US Dollar",
            height: 128,
            width: 128
        },
        MANA: {
            asset: "Replace_MANA.png",
            color: "#ff2d54",
            shortName: "MANA",
            name: "MANA",
            height: 128,
            width: 128
        },
        SOL: {
            asset: "SOL.png",
            color: "#8a53f4",
            shortName: "SOL",
            name: "Solana",
            height: 128,
            width: 128
        },
        SHIB: {
            asset: "Replace_Shiba-Inu.png",
            color: "#ffa509",
            shortName: "SHIB",
            name: "Shiba Inu",
            height: 128,
            width: 128
        },
        MATIC: {
            asset: "Replace_Polygon.png",
            color: "#844aea",
            shortName: "MATIC",
            name: "Polygon",
            height: 128,
            width: 128
        },
        AVAX: {
            asset: "New_AVAX.png",
            color: "#e84142",
            shortName: "AVAX",
            name: "Avalanche",
            height: 128,
            width: 128
        },
        BUSD: {
          asset: "New_BUSD.png",
          color: "#f0b90b",
          shortName: "BUSD",
          name: "Binance USD",
          height: 128,
          width: 128
        },
        IMX: {
          asset: "New_IMX.png",
          color: "#17b5cb",
          shortName: "IMX",
          name: "Immutable X",
          height: 118,
          width: 118
        },
        USDT: {
          asset: "New_USDT.png",
          color: "#1ba27a",
          shortName: "USDT",
          name: "Tether",
          height: 128,
          width: 128
        },
        CHZ: {
          asset: "icon_CHZ.png",
          color: "#cd0124",
          shortName: "CHZ",
          name: "Chiliz",
          height: 128,
          width: 128
        },
        HON: {
          asset: "icon_HON.png",
          color: "#6f66f9",
          shortName: "HON",
          name: "WonderHero",
          height: 118,
          width: 118
        },
        MSFT: {
          asset: "icon_MSFT.png",
          color: "#00c46b",
          shortName: "MSFT",
          name: "Currency.com",
          height: 108,
          width: 108
        },
        TT: {
          asset: "icon_TT.png",
          color: "#ffe81c",
          shortName: "TT",
          name: "ThunderCore",
          height: 128,
          width: 128
        },
        AAPL: {
          asset: "icon_AAPL.png",
          color: "#008c00",
          shortName: "AAPL",
          name: "AAPL",
          height: 128,
          width: 103
        },
        AXS: {
          asset: "Axie-Infinity-AXS-logo.png",
          color: "#0055d5",
          shortName: "AXS",
          name: "Axie Infinity",
          height: 128,
          width: 128
        },
        BOND: {
          asset: "BarnBridge-BOND-logo.png",
          color: "#ff4338",
          shortName: "BOND",
          name: "BarnBridge",
          height: 128,
          width: 128
        },
        FET: {
          asset: "Fetch-FET-logo.png",
          color: "#11155d",
          shortName: "FET",
          name: "Fetch.ai",
          height: 128,
          width: 128
        },
        MKR: {
          asset: "Maker-MKR-Logo.png",
          color: "#63c4b3",
          shortName: "MKR",
          name: "Maker",
          height: 128,
          width: 128
        },
        OXT: {
          asset: "Orchid-OXT-Logo.png",
          color: "#5f45ba",
          shortName: "OXT",
          name: "Orchid",
          height: 128,
          width: 128
        },
        DOT: {
          asset: "Polkadot-DOT-logo.png",
          color: "#e6007a",
          shortName: "DOT",
          name: "Polkadot",
          height: 128,
          width: 128
        },
        REN: {
          asset: "Ren-REN-Logo.png",
          color: "#0f3158",
          shortName: "REN",
          name: "Ren",
          height: 128,
          width: 128
        },
        XRP: {
          asset: "Ripple-XRP-logo.png",
          color: "#23292f",
          shortName: "XRP",
          name: "Ripple",
          height: 128,
          width: 128
        }
    };
    communityDisplayMap = [
    {
      name: "PleasrDAO via The Doge NFT ($DOG)",
      asset: "assets/communities/og-doge.png"
    },
        {
            name: "Evolution Apes NFT",
            asset: "assets/communities/Evolution-Apes-NFT.jpg"
        },
        {
            name: "#CleanNFT artists",
            asset: "assets/communities/CleanNFT-artists.jpg"
        },
        {
            name: "Crypto Rand",
            asset: "assets/communities/Crypto-Rand.png"
        },
        {
            name: "Creepy Creams NFT",
            asset: "assets/communities/Creepy-Creams-NFT.jpg"
        },
        {
            name: "Flower Girls NFT",
            asset: "assets/communities/Flower-Girls-NFT.jpg"
        },
        {
            name: "GOATz 4 KIDz NFT",
            asset: "assets/communities/GOATz-4-KIDz-NFT.jpg"
        },
        {
            name: "Heal The World NFT",
            asset: "assets/communities/Heal-the-World-NFT.png"
        },
        {
            name : "Not Your Bro NFT",
            asset: "assets/communities/Not-Your-Bro-NFT.jpg"
        },
        {
            name: "Nightingale of Peace",
            asset: "assets/communities/The-Nightengale-of-Peace.jpg"
        },
        {
            name: "PleasrDAO - Doge NFT",
            asset: "assets/communities/pleasr128.png"
        },
    {
      name: "MUNCH token",
      asset: "assets/communities/MUNCHToken128.png"
    },
    {
      name: "Crypto Pills",
      asset: "assets/communities/cryptopills128x128.png"
    },
    {
      name: "PYE",
      asset: "assets/communities/CreamPYE128.png"
    },
    {
      name: "Solagon.IO",
      asset: "assets/communities/solagon128.png"
    },
    {
      name: "Saint Inu",
      asset: "assets/communities/saintinu128.png"
    },
    {
      name: "Santa Floki",
      asset: "assets/communities/santafloki128.png"
    },
    {
      name: "Pyromaniac",
      asset: "assets/communities/pyromaniac128.png"
    },
    {
      name: "Red Pandas NFT",
      asset: "assets/communities/redpandas128.png"
    },
    {
      name: "Holy Cows NFT",
      asset: "assets/communities/holycows128.png"
    },
    {
      name: "The Bull Runners",
      asset: "xxxxxxxxx.png"
    },
    {
      name: "Shattered Marble NFT",
      asset: "xxxxxxxxxxx.png"
    },
    {
      name: "Fractal Dimension NFT",
      asset: "xxxxxxxxxx.png"
    },
    {
      name: "Decentralized Bone Society",
      asset: "assets/communities/DBS128.png"
    },
    {
      name: "ERTH Token",
      asset: "assets/communities/ERTHtoken128.png"
    },
    {
      name: "NFT Llama",
      asset: "xxxxxxxxxxxx.png"
    },
    {
      name: "Webamooz.com",
      asset: "xxxxxxxxxxxx.png"
    },
    {
      name: "Shattered Marble",
      asset: "assets/communities/shatteredmarblex128.jpg"
    },
    {
      name: "Dead Dude Project",
      asset: "assets/communities/xxxxxxxxxxxx.png"
    },
    {
      name: "Rainbow Token",
      asset: "xxxxxxxxxxx.png"
    },
    {
      name: "Chubby Satan NFT",
      asset: "xxxxxxxxxxx.png"
    },
    {
      name: "Ethereum party",
      asset: "xxxxxxxxxxxxxx.png"
    },
    {
      name: "Crumbys Bakery",
      asset: "xxxxxxxxxxxxx.png"
    },
        {
            name: "SolChicks",
            asset: "assets/communities/SolChicks.png"
        },
        {
            name: "ZigZag Team",
            asset: "assets/communities/zigzag.jpg"
        },
        {
            name: "HAPEBEAST NFT",
            asset: "assets/communities/HapeBeast.jpg"
        },
        {
            name: "Clu Coin",
            asset: "assets/communities/clucoin128.png"
        },
        {
            name: "AnjiEco",
            asset: "assets/communities/anjieco.png"
        },
        {
            name:"White Rabbit NFT",
            asset:"assets/communities/whiterabbitNFT.jpg"
        },
        {
            name:"World of Women via Code Green",
            asset:"assets/communities/worldofwomen+code-green.png"
        },
        {
            name:"The SolaVerse Companions",
            asset:"assets/communities/The-Solaverse.jpg"
        },
        {
            name:"WonderZone",
            asset:"assets/communities/wonderzone.jpg"
        },
        {
            name:"OnChainMonkey OCM Earth NFT",
            asset:"assets/communities/OCM-Earth-NFT.png"
        }
  ];


    // url = "//127.0.0.1:8080/tokenValues";
    url = "//hodlhope.org/api/tokenValues";
  donationData = {};
  tokenValues = [];
  topTokenValues =[];
  communityValues = [];
  donorValues = [];

  constructor(private http: HttpClient) {

      this.loadAPI = new Promise((resolve) => {
          resolve(true);
      });


    this.getTokenData().subscribe(
      (response) => {
        this.donationData = response;

        // parse out the top tokens (BTC / ETH) vs. the rest of the tokens
        var tempTokenValues = response["tokenValues"];
        for (let i = 0; i < tempTokenValues.length; i++){
            if (tempTokenValues[i].name == "BTC" || tempTokenValues[i].name == "ETH") {
                this.topTokenValues.push(tempTokenValues[i]);
            } else {
                this.tokenValues.push(tempTokenValues[i]);
            }
        }
        this.tokenValues.sort((a, b) => (a.fiatValue < b.fiatValue) ? 1 : -1);
        this.topTokenValues.sort((a, b) => (a.fiatValue < b.fiatValue) ? 1 : -1);
        // end parse of tokens

        // parse out the communities vs. the donors
        var tempCommunity = response["communityValues"];
        for (var i = 0; i < tempCommunity.length; i++) {
            let exists = false;
            for (var j = 0; j < this.communityDisplayMap.length; j++) {
                if (this.communityDisplayMap[j].name == tempCommunity[i].name) {
                    this.communityValues.push(tempCommunity[i]);
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                console.log("Non Community: ", tempCommunity[i]);
                this.donorValues.push(tempCommunity[i]);
            }
        }
        this.communityValues.sort( (a,b) => (a.fiatValue < b.fiatValue) ? 1 : -1);
        this.donorValues.sort( (a,b) => (a.fiatValue < b.fiatValue) ? 1 : -1);
        // end parse of community / donor values


        },
      (error) => { console.log(error); });
  }

  public imageAssetForCommunity(name): string {
    for (var i = 0; i < this.communityDisplayMap.length; i++) {
      if (this.communityDisplayMap[i].name == name) {
        return this.communityDisplayMap[i].asset;
      }
    }

    return "";
  }


  private formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  public limitNumberWithinRange(num, min, max){
    const MIN = min || 1;
    const MAX = max || 20;
    const parsed = parseInt(num)
    return Math.min(Math.max(parsed, MIN), MAX)
  }

  public formatRevenueData(value): string {
    return this.formatter.format(value);
  }

  public showPercentage(value): boolean {
    return this.revenuePercentOfTotalRevenue(value) > 0
  }

  public tokenShortNameToLongName(token): string {
    if (this.tokenDisplayMap[token]) {
      return this.tokenDisplayMap[token].name;
    } else {
      return token;
    }
  }

  public communityNameFormatter(name){
    if (name) {
      return name;
    } else {
      return "Anonymous";
    }
  }

  public revenuePercentOfGoal(value): number {
    if (value == 0 || value == undefined) { return 0; }
    return Math.round((value / this.revenueGoal) * 100);
  }

  public revenuePercentOfTotalRevenue(value): number {
    if (value == 0 || value == undefined) { return 0; }
    if (this.donationData["totalRevenue"] == 0 || this.donationData["totalRevenue"] == undefined) { return 0; }
    return Math.round((value / this.donationData["totalRevenue"]) * 100);
  }


  getTokenData(){
    return this.http.get(this.url);
  }


    loadAPI: Promise<any>;
  
  ngAfterViewInit() {
    (function (e,i,n,g,x,r,s,d,a,y,w,q,c,o){
      var p="tgbWidgetOptions";
      if (e[p]) {
        if (!e[p].length) {
          e[p] = [e[p]];
        }
        e[p].push({id:r,apiUserUuid:x,domain:g,buttonId:d,scriptId:s,uiVersion:a,donationFlow:y,fundraiserId:w,campaignId:q})
      } else {
        e[p]={id:r,apiUserUuid:x,domain:g,buttonId:d,scriptId:s,uiVersion:a,donationFlow:y,fundraiserId:w,campaignId:q};
      }
      c=i.createElement(n);
      c.src=[g,"/widget/script.js"].join("");
      c.async=1;
      o=i.getElementById(s);
      o.parentNode.insertBefore(c,o);  
      i.getElementById(d).addEventListener("click",function(event){event.preventDefault();},false);
    })(window,document,"script","https://widget.thegivingblock.com","e6cf7d18-41b6-4a6c-954a-338578fd90b0",  "3","tgb-widget-script","tgb-widget-button",  "2", "crypto", "", "");
  }

}
